export default __webpack_public_path__ + "static/media/resolved-icon.e1ac5d02.svg";